<div class="verfy-wrap">
  <div class="verfy-screen-logo">
    <img alt="" class="verify-agency-logo" src="{{ agencyPicture }}" />
  </div>
  <div class="verfy-box">
    <div *ngIf="!linkExpired">
      <h2>Download File</h2>
      <p>Enter your date of birth to download file.</p>
      <form (ngSubmit)="submitForm()">
        <div class="Verify-dob">
          <img alt="" src="../../assets/images/calendar.svg" />
          <p-inputMask
            *ngIf="innerWidth <= 1024"
            [(ngModel)]="dob"
            name="dob"
            mask="99/99/9999"
            placeholder="mm-dd-yyyy"
            slotChar="mm/dd/yyyy"
            class="input-mask-field"
          ></p-inputMask>
          <p-calendar
            *ngIf="innerWidth > 1024"
            [(ngModel)]="dob"
            class="w-full disable-calendar"
            dateFormat="{{ dobDateFormat }}"
            dateMask="99/99/9999"
            placeholder="mm-dd-yyyy"
            name="dob"
          ></p-calendar>
        </div>
        <button class="w-full mt-4" pButton type="submit">Submit</button>
      </form>
    </div>
    <div *ngIf="linkExpired">
      <h2>Request link again?</h2>
      <p>Current Link is expired. Request for new link to download your file.</p>
      <button (click)="resendLink()" class="w-full mt-4" pButton>Request New Link</button>
    </div>
  </div>
  <div class="powered-wrapper">
    <span class="text-center">Powered by</span>
    <div class="image-wrapper">
      <img alt="" src="assets/images/io-logo-green.svg" />
    </div>
  </div>
</div>
